import es from './es';
import en from './en-US';

let MESSAGES = {};
MESSAGES.es  = es;
MESSAGES['en-US'] = en;

export function message ( text ) {
  let locale = localStorage.locale || 'es';
  let msg = MESSAGES[locale][text];

  return msg;
}



// WEBPACK FOOTER //
// ./src/translate/index.js